import Hero from './components/Hero';
import Problem from './components/Problem';
import FlightPath from './components/FlightPath';
import IndustryModules from './components/IndustryModules';
import Results from './components/Results';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Problem />
      <FlightPath />
      <IndustryModules />
      <Results />
      <FinalCTA />
    </div>
  );
}
